import { z } from "zod";
/**
 * A DLQ count is meaningful only when it is scoped to one source and carries
 * the time at which that observation was made. The physical shared
 * subscription metric remains the operational authority for the queue.
 */
export const sourceDlqObservationSchema = z
    .object({
    scope: z.literal("source"),
    sourceId: z.string().uuid(),
    depth: z.number().int().nonnegative(),
    observedAt: z.string().datetime({ offset: true }),
})
    .strict();
/**
 * Source observations are displayable for fifteen minutes. This is a
 * presentation freshness bound, not a queue retention or replay policy.
 */
export const SOURCE_DLQ_OBSERVATION_MAX_AGE_MS = 15 * 60 * 1000;
export function sourceDlqObservationState(observation, sourceId, now = Date.now()) {
    if (!observation || observation.scope !== "source" || observation.sourceId !== sourceId) {
        return "unavailable";
    }
    const observedAt = Date.parse(observation.observedAt);
    const nowMs = typeof now === "number" ? now : now.getTime();
    if (!Number.isFinite(observedAt) || !Number.isFinite(nowMs) || observedAt > nowMs) {
        return "unavailable";
    }
    return nowMs - observedAt <= SOURCE_DLQ_OBSERVATION_MAX_AGE_MS ? "current" : "stale";
}
//# sourceMappingURL=source-health.js.map